import { useFormik } from "formik";
import { PersonaInvDTO } from "../../interfaces/Usuarios/PersonaInvDTO"
import { Alert, Box, Button, Container, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import AlertService from "../../services/AlertService";
import UsuarioService from "../../services/UsuarioService";
import { IoMdAddCircle } from "react-icons/io";
import { TiDelete } from "react-icons/ti";
import CatalogService from "../../services/CatalogService";
import { VoidRolesInvUnidadDTO } from "../../interfaces/Usuarios/RolPersonaUnidadDTO";
import { useEffect, useState } from "react";
import { Unidad } from "../../interfaces/Unidad";
import { IndexacionDTO } from "../../interfaces/IndexacionDTO";
import { UsuarioValidate } from "../ValidationForm/validationForm";

interface Props {
    usuario: PersonaInvDTO,
    token: any,
    editorOrcId?: boolean,
    onResponse?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
}

const alertService = new AlertService();
const usuarioService = new UsuarioService();
const catalagoService = new CatalogService();

export const UserForm: React.FC<Props> = ({ usuario, token, editorOrcId = false, onResponse }) => {
    let [ready, setReady] = useState(false);
    const [unidades, setUnidades] = useState<Array<Unidad>>([])
    const [rolesInvestigacion, setRolesInvestigacion] = useState<Array<IndexacionDTO>>([])
    const formik = useFormik<PersonaInvDTO>({
        initialValues: usuario,
        validationSchema: UsuarioValidate,
        onSubmit: (values) => {
            //console.log(values);
            Guardar(values);
        }
    });
    const optionesEstado = catalagoService.getEstadoAoI();
    //#region funciones
    const fetchData = async () => {
        await catalagoService.obtenerCatalogoUnidades()
            .then((data) => setUnidades(data.objDatos))
            .catch((error) => console.error(error))
        let Roles = await catalagoService.obtenerGetRolInvestigador()
        if (Roles.status.isSuccessfully) {
            setRolesInvestigacion(Roles.listData);
        } else {
            console.log(Roles.status.messages)
        }
        setReady(true);
    }
    function AgregarRol() {
        let rol = VoidRolesInvUnidadDTO();
        formik.setFieldValue('roles', [...formik.values.roles, rol]);
    }
    function RemoverRol(index: number) {
        //formik.setFieldValue('roles',[...formik.values.roles, VoidRolesInvUnidadDTO()])
        console.log(index)
        const updatedRoles = [...formik.values.roles];
        const idToRemove = updatedRoles[index].idrolpersona;
        if (idToRemove === 0) {
            updatedRoles.splice(index, 1);
            formik.setFieldValue('roles', updatedRoles);
        } else {
            //aqui colocar funcion para eliminar
            console.log("tiene ID: ", idToRemove);
        }
    }
    const obtenerScopusId = async (orcid: string) => {
        alertService.showLoading('Consultando scopus id');
        let orcidNew = orcid.replaceAll('-', '')
        let response = await usuarioService.GetScopusID(orcidNew);
        if (response == undefined) {
            alertService.alertaAdvertencia('Alerta', 'No se obtuvo un resultado válido')
            formik.setFieldValue('scopusid', '');
            return
        }
        //console.log(response)
        const jsonString = JSON.stringify(response);
        const parsedObject = JSON.parse(jsonString);
        const letScopus = parsedObject.data['search-results'].entry[0]['dc:identifier']
        if (letScopus == undefined) {
            alertService.alertaAdvertencia('No encontrado', 'No se ha obtenido resultado')
            formik.setFieldValue('scopusid', '');
            return
        }
        const idScopus = letScopus.split(':')[1];
        alertService.hideLoading();
        formik.setFieldValue('scopusid', idScopus);
    };
    const Guardar = async (values: PersonaInvDTO) => {
        //console.log("Post", values);
        alertService.showLoading("Guardando nuevo usuario...");
        const resp = await usuarioService.PostRolesUsuario(values, token);
        alertService.hideLoading();
        //console.log(resp)
        if (resp.status.isSuccessfully) {
            if (values.iddecinvuser == 0) {
                alertService.alertaExito("Exito", "El nuevo usuario ha sido guardado");
            } else {
                alertService.alertaExito("Exito", "Se actualizaron los datos del usuario");
            }
            //console.log(resp.data);
            if (onResponse) {
                onResponse(resp.data);
            } else {
                console.error('La función onResponse no está definida.');
            }
        } else {
            alertService.alertaAdvertencia("Alerta", resp.status.messages.toString());
        }
    }
    //#endregion
    //#region Use Effect
    useEffect(() => {
        fetchData();
    }, [token]);
    //#endregion
    return (
        <Container maxWidth="xl" style={{ border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                Formulario Usuario
            </Typography>
            {ready ?
                <form onSubmit={formik.handleSubmit}>
                    <Grid container direction={'row'} spacing={1}>
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                id="namefull"
                                sx={{
                                    width: '100%',
                                    '& .MuiInputBase-input.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del texto
                                        WebkitTextFillColor: 'rgba(0, 0, 0, 1)', // Color del texto en Webkit browsers
                                        backgroundColor: 'rgba(0, 0, 0, 0)', // Color de fondo
                                    },
                                    '& .MuiOutlinedInput-notchedOutline.Mui-disabled': {
                                        borderColor: 'rgba(0, 0, 0, 0.2)', // Color del borde
                                    },
                                    '& .MuiInputLabel-root.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del label
                                    },
                                }}
                                label="Nombre:"
                                variant="outlined"
                                value={formik.values.nombreCompleto}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                id="identificacion"
                                sx={{
                                    width: '100%',
                                    '& .MuiInputBase-input.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del texto
                                        WebkitTextFillColor: 'rgba(0, 0, 0, 1)', // Color del texto en Webkit browsers
                                        backgroundColor: 'rgba(0, 0, 0, 0)', // Color de fondo
                                    },
                                    '& .MuiOutlinedInput-notchedOutline.Mui-disabled': {
                                        borderColor: 'rgba(0, 0, 0, 0.2)', // Color del borde
                                    },
                                    '& .MuiInputLabel-root.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del label
                                    },
                                }}
                                label="Identificación:"
                                variant="outlined"
                                value={formik.values.numeroidentificacion}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                id="Correo:"
                                sx={{
                                    width: '100%',
                                    '& .MuiInputBase-input.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del texto
                                        WebkitTextFillColor: 'rgba(0, 0, 0, 1)', // Color del texto en Webkit browsers
                                        backgroundColor: 'rgba(0, 0, 0, 0)', // Color de fondo
                                    },
                                    '& .MuiOutlinedInput-notchedOutline.Mui-disabled': {
                                        borderColor: 'rgba(0, 0, 0, 0.2)', // Color del borde
                                    },
                                    '& .MuiInputLabel-root.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 1)', // Color del label
                                    },
                                }}
                                label="Correo:"
                                variant="outlined"
                                value={formik.values.email}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={9}>
                            <FormControl fullWidth error={Boolean(formik.errors.orcid && formik.touched.orcid)}>
                                <TextField
                                    fullWidth
                                    id="orcid"
                                    name="orcid"
                                    label="Orcid:"
                                    value={formik.values.orcid}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.orcid && Boolean(formik.errors.orcid)}
                                    sx={{ width: '100%' }}
                                />
                                {formik.touched.orcid && formik.errors.orcid && (
                                    <Alert severity="error">{formik.errors.orcid}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} >
                            <Button style={{ backgroundColor: '#517ED3', color: 'white', width: '50%' }} onClick={() => obtenerScopusId(formik.values.orcid)}>Consultar Scopus ID</Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth error={Boolean(formik.errors.scopusid && formik.touched.scopusid)}>
                                <TextField
                                    fullWidth
                                    id="scopusid"
                                    name="scopusid"
                                    label="Scopusid:"
                                    value={formik.values.scopusid}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.scopusid && Boolean(formik.errors.scopusid)}
                                    sx={{ width: '100%' }}
                                />
                                {formik.touched.scopusid && formik.errors.scopusid && (
                                    <Alert severity="error">{formik.errors.scopusid}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth error={Boolean(formik.errors.hindex && formik.touched.hindex)}>
                                <TextField
                                    fullWidth
                                    id="hindex"
                                    name="hindex"
                                    label="Hindex:"
                                    value={formik.values.hindex}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.hindex && Boolean(formik.errors.hindex)}
                                    sx={{ width: '100%' }}
                                    disabled={editorOrcId}
                                />
                                {formik.touched.hindex && formik.errors.hindex && (
                                    <Alert severity="error">{formik.errors.hindex}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth error={Boolean(formik.errors.scholarid && formik.touched.scholarid)}>
                                <TextField
                                    fullWidth
                                    id="scholarid"
                                    name="scholarid"
                                    label="Scholarid:"
                                    value={formik.values.scholarid}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.scholarid && Boolean(formik.errors.scholarid)}
                                    sx={{ width: '100%' }}
                                    disabled={editorOrcId}
                                />
                                {formik.touched.scholarid && formik.errors.scholarid && (
                                    <Alert severity="error">{formik.errors.scholarid}</Alert>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Paper elevation={3} style={{ padding: '16px', border: '1px solid #517ED3' }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="body1" style={{ fontWeight: 'bold', color: '#517ED3' }}>
                                        Roles
                                    </Typography>
                                    <Box>
                                        {editorOrcId ?
                                            <></>
                                            :
                                            <IconButton aria-label="agregar" color='info' onClick={() => AgregarRol()}>
                                                <IoMdAddCircle />
                                            </IconButton>
                                        }
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Rol</TableCell>
                                        <TableCell>Unidad</TableCell>
                                        <TableCell>Estado</TableCell>
                                        {/* <TableCell>Eliminar</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {formik.values.roles.length > 0 ?
                                        <>
                                            {formik.values.roles.map((rol, index) => (
                                                <TableRow key={'rol-' + index}>
                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        <Select
                                                            labelId="select-rol"
                                                            name={`roles[${index}].idrol`}
                                                            variant="outlined"
                                                            value={rol.idrol}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{ marginBottom: '20px', width: '100%' }}
                                                            disabled={editorOrcId}
                                                        >
                                                            {rolesInvestigacion.length > 0 ? (
                                                                rolesInvestigacion.map((tipoP) => (
                                                                    <MenuItem key={tipoP.id} value={tipoP.id}>
                                                                        {tipoP.descripcion}
                                                                    </MenuItem>
                                                                ))
                                                            )
                                                                : (
                                                                    <MenuItem value={''}>SELECCIONE UN ROL</MenuItem>
                                                                )}
                                                        </Select>
                                                    </TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        <Select
                                                            labelId="select-unidad"
                                                            name={`roles[${index}].idunidad`}
                                                            variant="outlined"
                                                            value={rol.idunidad}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{ marginBottom: '20px', width: '100%' }}
                                                            disabled={editorOrcId}
                                                        >
                                                            {unidades.length > 0 ? (
                                                                unidades.map((tipoP) => (
                                                                    <MenuItem key={tipoP.idunidad} value={tipoP.idunidad}>
                                                                        {tipoP.codacad}-{tipoP.nombreunidad.length > 24 ? tipoP.nombreunidad.substring(0, 24) + ".." : tipoP.nombreunidad}
                                                                    </MenuItem>
                                                                ))
                                                            )
                                                                : (
                                                                    <MenuItem value={''}>SELECCIONE UNA UNIDAD</MenuItem>
                                                                )}
                                                        </Select>
                                                    </TableCell>
                                                    <TableCell style={{ width: '50%' }}>
                                                        <Select
                                                            labelId="select-estado"
                                                            name={`roles[${index}].estado`}
                                                            variant="outlined"
                                                            value={rol.estado}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{ marginBottom: '20px', width: '100%' }}
                                                            disabled={editorOrcId}
                                                        >
                                                            {optionesEstado.length > 0 ? (
                                                                optionesEstado.map((tipoP) => (
                                                                    <MenuItem key={tipoP.value} value={tipoP.value}>
                                                                        {tipoP.label}
                                                                    </MenuItem>
                                                                ))
                                                            )
                                                                : (
                                                                    <MenuItem value={''}>SELECCIONE ESTADO</MenuItem>
                                                                )}
                                                        </Select>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                        : <></>}

                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Button style={{ backgroundColor: '#517ED3', color: 'white', width: '50%', borderRadius: '25px' }} variant="contained" type="submit">
                                GUARDAR
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                :
                <></>
            }
        </Container>
    )
}